export const LozengeAriaDescriptions = {
  PRO: 'Pro indicator: A premium offering that requires a paid subscription.',
  BETA: 'Beta version: An early release with experimental features that may change.',
  FREE: 'Free plan: This option is available at no cost with limited features.',
  AI: 'AI-powered feature: Enhanced functionality driven by artificial intelligence.',
  LIVE: 'Live status: Currently active or broadcasting in real time.',
  STOPPED: 'Service stopped: This option indicates that the service is not running.',
  POPULAR: 'Popular choice: Frequently selected or widely recognized among users.',
  NEW: 'New release: Recently introduced, offering the latest features and improvements.',
}
